/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { mapActions, mapGetters } from 'vuex';
import GlobalAlertsCommon from './GlobalAlertsCommon.vue';

export default GlobalAlertsCommon.extend({
  name: 'GlobalAlerts',
  computed: {
    ...mapGetters({
      alertList: 'alerts/list',
    }),
  },
  // TODO: Remove this hook once all pages are SPA
  created() {
    const msg = JSON.parse(sessionStorage.getItem('notifyNextLoad') || 'null');
    if (msg) {
      this.showAlert(msg);
      sessionStorage.removeItem('notifyNextLoad');
    }
  },
  methods: {
    ...mapActions({
      hideAlert: 'alerts/hideOne',
      showAlert: 'alerts/show',
    }),
  },
});
